import React, { FC } from 'react'

import { UseFormRegister } from 'react-hook-form'

import { Txt, Tooltip } from 'src/components/atoms'
import { AttributeMappingInputItem } from 'src/components/molecules/settings/AttributeMappingInputItem'

import { SamlIdpFormEntity } from 'src/types'

type Props = {
  register: UseFormRegister<SamlIdpFormEntity>
  className?: string
}

export const AttributeMappingInput: FC<Props> = ({ register, className }) => {
  return (
    <div className={className}>
      <div className="tw-full-justify">
        <Tooltip
          placement="top"
          content={
            <Txt sizeType="s">
              IdPの属性をWORKSの属性にマッピングします。WORKS
              <br />
              がIdPのユーザー属性を認識するためには、IdPの属性を
              <br />
              WORKSの属性にマッピングする必要があります。
            </Txt>
          }
        >
          <Txt className="tw-font-bold">属性マッピング</Txt>
        </Tooltip>
      </div>

      <Txt className="tw-text-standardText-secondary tw-mt-s1">
        Googleの場合は「email」、 Microsoft Entra
        IDの場合は「http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name」を入力ください。その他の場合はIdPのヘルプページを参照ください。
      </Txt>

      <div className="tw-grid tw-gap-s2 tw-mt-s2">
        <AttributeMappingInputItem
          register={register('attributeMapping.email')}
          attribute="email"
          required
        />
        <AttributeMappingInputItem
          register={register('attributeMapping.name')}
          attribute="name"
          placeholder="名前属性を入力（省略可）"
        />
        <AttributeMappingInputItem
          register={register('attributeMapping.department')}
          attribute="department"
          placeholder="部署属性を入力（省略可）"
        />
      </div>
    </div>
  )
}
